import React from 'react';
import { useIntl } from 'react-intl';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages.json';
import LinkAndAnchor from '../../LinkAndAnchor';
import {
  getArticleUrl,
  Locale,
  NewsArticleUrlFields,
} from '../../../lib/selectTranslatedArticleLinks';

const TranslationLink = ({
  locale,
  article,
}: {
  locale: Locale;
  article: NewsArticleUrlFields;
}) => {
  const { origin } = useSiteContext();

  return (
    <>
      {' '}
      <LinkAndAnchor
        useRouter={false}
        href={getArticleUrl(article, origin, locale)}
      >
        { locale.replace(/-.+/, '') }
      </LinkAndAnchor>
      {' '}
    </>
  );
};

interface TranslationLinksProperties {
  translationsByLanguage: Record<
    string,
    { locale: Locale; newsArticle: NewsArticleUrlFields }
  >;
  originalArticle: {
    locale: Locale;
    newsArticle: NewsArticleUrlFields | undefined;
  } | null | undefined;
}

const TranslationLinks = ({
  translationsByLanguage,
  originalArticle,
}: TranslationLinksProperties) => {
  const intl = useIntl();
  const translationLanguages = Object.keys(translationsByLanguage);

  return (
    <>
      {originalArticle?.newsArticle && (
        <>
          <span>{intl.formatMessage(messages.readTheOriginal)}</span>
          <TranslationLink
            key={originalArticle.locale}
            locale={originalArticle.locale}
            article={originalArticle.newsArticle}
          />
        </>
      )}
      {originalArticle && translationLanguages.length > 0 && (
        <span>{intl.formatMessage(messages.or)}</span>
      )}
      {translationLanguages.length > 0
        && translationLanguages.map((translationKey) => {
          const {
            locale: translationLocale,
            newsArticle,
          } = translationsByLanguage[translationKey];

          return (
            <TranslationLink
              key={translationLocale}
              locale={translationLocale}
              article={newsArticle}
            />
          );
        })}
    </>
  );
};

export default TranslationLinks;
